exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body span[data-v-6d5ea250]{vertical-align:inherit}.map-legend ul[data-v-6d5ea250]{margin-left:0;margin-bottom:0}.map-legend ul li[data-v-6d5ea250]{list-style-type:none}.map-legend .legend-style.new-generation[data-v-6d5ea250]{margin-top:2px}.map-legend .legend-style svg[data-v-6d5ea250]{vertical-align:middle}", ""]);

// exports
